<template>
  <div>
    <el-card>
      <div slot="header">
        <span>人员管理</span>
        <router-link :to="{ path: './add' }">
          <el-button
            style="float: right"
            type="primary"
            size="small"
          >
            新增
          </el-button>
        </router-link>
      </div>
      <el-form size="small" inline>
        <el-form-item>
          <el-input
            placeholder="员工姓名"
            v-model="employeeName"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="search"
          >
            搜索
          </el-button>
        </el-form-item>
      </el-form>
      <el-row :gutter="10" style="min-height: 520px">
        <el-col :span="3" v-for="(item, index) in employeeData" :key="index">
          <el-card
            :body-style="{ padding: '6px' }"
            style="margin: 0 0 10px 0; cursor: pointer"
          >
            <el-row>
              <el-col :span="20">
                <el-button icon="el-icon-s-custom" circle></el-button>
              </el-col>
              <el-col :span="4">
                <el-tooltip effect="dark" content="进入编辑" placement="top">
                  <el-button
                    icon="el-icon-edit"
                    type="success"
                    circle
                    size="large"
                    style="padding: 4px;margin-top: 3px"
                    @click="update(item.id)"
                  />
                </el-tooltip>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <p style="margin: 8px">{{ item.name }}</p>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <p style="margin: 8px">
                  {{item.phone}}
                </p>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <p style="margin: 8px">
                  {{item.role | roleString}}
                </p>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
      <div style="margin-top: 12px; text-align: center">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[16]"
          :page-size="value"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-card>
<!--    <el-row :gutter="10">-->
<!--      <el-col :span="12">-->
<!--        <div class="employListbox">-->
<!--          <div style="display: flex; justify-content: space-between">-->
<!--            <div>-->
<!--              <el-popconfirm-->
<!--                title="是否进入新建计划表单"-->
<!--                @confirm="addEmployee"-->
<!--                @cancel="cancel"-->
<!--              >-->
<!--                <el-button type="primary" size="small" slot="reference"-->
<!--                >新增</el-button-->
<!--                >-->
<!--              </el-popconfirm>-->
<!--            </div>-->
<!--            <div style="text-align: right">-->
<!--              <el-input-->
<!--                v-model="employeeName"-->
<!--                placeholder="员工姓名"-->
<!--                size="small"-->
<!--                style="width: 74%"-->
<!--              ></el-input>-->
<!--              <el-button type="primary" @click="search" size="small"-->
<!--              >搜索</el-button-->
<!--              >-->
<!--            </div>-->
<!--          </div>-->
<!--          <el-table :data="employeeData" style="width: 100%" height="535">-->
<!--            <el-table-column prop="id" label="编号"> </el-table-column>-->
<!--            <el-table-column prop="name" label="姓名"> </el-table-column>-->
<!--            <el-table-column width="120" prop="phone" label="手机号">-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="role" label="工种">-->
<!--              <template slot-scope="scope">-->
<!--                {{ scope.row.role | roleString }}-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column label="操作" width="150">-->
<!--              <template slot-scope="scope">-->
<!--                <el-tooltip-->
<!--                  class="item"-->
<!--                  effect="dark"-->
<!--                  content="编辑"-->
<!--                  placement="top"-->
<!--                >-->
<!--                  <el-button-->
<!--                    icon="el-icon-edit"-->
<!--                    type="warning"-->
<!--                    circle-->
<!--                    size="large"-->
<!--                    style="padding: 4px"-->
<!--                    @click="update(scope.row)"-->
<!--                  ></el-button>-->
<!--                </el-tooltip>-->
<!--                <el-tooltip-->
<!--                  class="item"-->
<!--                  effect="dark"-->
<!--                  content="删除"-->
<!--                  placement="top"-->
<!--                >-->
<!--                  <el-button-->
<!--                    icon="el-icon-delete"-->
<!--                    type="danger"-->
<!--                    disabled-->
<!--                    circle-->
<!--                    size="large"-->
<!--                    style="padding: 4px"-->
<!--                    @click="remove(scope.row.id)"-->
<!--                  ></el-button>-->
<!--                </el-tooltip>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--          </el-table>-->
<!--          <div style="margin-top: 12px; text-align: center">-->
<!--            <el-pagination-->
<!--              @size-change="handleSizeChange"-->
<!--              @current-change="handleCurrentChange"-->
<!--              :current-page="pageNum"-->
<!--              :page-sizes="[10, 20, 30, 40]"-->
<!--              :page-size="value"-->
<!--              layout="total, sizes, prev, pager, next, jumper"-->
<!--              :total="total"-->
<!--            >-->
<!--            </el-pagination>-->
<!--          </div>-->
<!--        </div>-->
<!--      </el-col>-->
<!--      <el-col :span="12">-->
<!--        <el-card class="box-card" style="min-height: 619px">-->
<!--          <h4 class="cardTitle" style="margin-top: -5px">-->
<!--            {{ title }}员工信息-->
<!--          </h4>-->
<!--          <div style="min-height: 550px">-->
<!--            <el-form-->
<!--              v-if="employeeFrom.id"-->
<!--              ref="roleForm"-->
<!--              v-model="roleForm"-->
<!--              label-width="80px"-->
<!--            >-->
<!--              <el-form-item label="工种" prop="role">-->
<!--                <el-select-->
<!--                  v-model="roleForm.role"-->
<!--                  size="small"-->
<!--                  placeholder="请选择工种"-->
<!--                >-->
<!--                  <el-option-->
<!--                    v-for="(item, index) in workOption"-->
<!--                    :key="index"-->
<!--                    :label="item.label"-->
<!--                    :value="item.value"-->
<!--                  ></el-option>-->
<!--                </el-select>-->
<!--                <el-button type="primary" size="small" @click="roleSave"-->
<!--                >保存角色信息</el-button-->
<!--                >-->
<!--              </el-form-item>-->
<!--              <el-divider></el-divider>-->
<!--            </el-form>-->

<!--            <el-form-->
<!--              ref="employeeFrom"-->
<!--              :model="employeeFrom"-->
<!--              :rules="rules"-->
<!--              size="small"-->
<!--              label-width="80px"-->
<!--            >-->
<!--              <el-row>-->
<!--                <el-form-item-->
<!--                  label="所属公司"-->

<!--                  style="width: 75%"-->
<!--                >-->
<!--                  <el-input-->
<!--                    v-model="employeeFrom.enterpriseName"-->
<!--                    :rows="6"-->
<!--                    disabled-->
<!--                  />-->
<!--                </el-form-item>-->
<!--                <el-form-item label="姓名" prop="name" style="width: 75%">-->
<!--                  <el-input-->
<!--                    v-model="employeeFrom.name"-->
<!--                    :rows="6"-->
<!--                    maxlength="30"-->
<!--                    placeholder="请输入员工姓名"-->
<!--                  />-->
<!--                </el-form-item>-->
<!--                <el-form-item label="手机号码" prop="phone" style="width: 75%">-->
<!--                  <el-input-->
<!--                    type="text"-->
<!--                    oninput="value=value.replace(/\D/g,'')"-->
<!--                    placeholder="请输入数字"-->
<!--                    v-model="employeeFrom.phone"-->
<!--                    maxlength="11"-->
<!--                  >-->
<!--                  </el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item-->
<!--                  v-if="employeeFrom.id"-->
<!--                  label="密码"-->
<!--                  style="width: 75%"-->
<!--                >-->
<!--                  <el-input-->
<!--                    v-model="employeeFrom.password"-->
<!--                    :rows="6"-->
<!--                    maxlength="30"-->
<!--                    placeholder="请输入密码"-->
<!--                  />-->
<!--                </el-form-item>-->
<!--                <el-form-item-->
<!--                  v-else-->
<!--                  label="密码"-->
<!--                  prop="password"-->
<!--                  style="width: 75%"-->
<!--                >-->
<!--                  <el-input-->
<!--                    v-model="employeeFrom.password"-->
<!--                    :rows="6"-->
<!--                    maxlength="30"-->
<!--                    placeholder="请输入密码"-->
<!--                  />-->
<!--                </el-form-item>-->
<!--                <el-col>-->
<!--                  <el-form-item-->
<!--                    label="工种"-->
<!--                    prop="role"-->
<!--                    v-if="!this.employeeFrom.id"-->
<!--                  >-->
<!--                    <el-select-->
<!--                      v-model="employeeFrom.role"-->
<!--                      placeholder="请选择工种"-->
<!--                    >-->
<!--                      <el-option-->
<!--                        v-for="(item, index) in workOption"-->
<!--                        :key="index"-->
<!--                        :label="item.label"-->
<!--                        :value="item.value"-->
<!--                      ></el-option>-->
<!--                    </el-select>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
<!--                <el-col> </el-col>-->
<!--                <el-col :span="12"> </el-col>-->
<!--                <el-col>-->
<!--                  <el-form-item label="">-->
<!--                    <el-button type="warning" @click="clearFrom"-->
<!--                    >清空</el-button-->
<!--                    >-->
<!--                    <el-button type="primary" @click="save"-->
<!--                    >保存个人信息</el-button-->
<!--                    >-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
<!--              </el-row>-->
<!--            </el-form>-->
<!--          </div>-->
<!--        </el-card>-->
<!--      </el-col>-->
<!--    </el-row>-->
  </div>
</template>

<script>
  // import { employeeAdd } from '@/api/basicInfoMange.js'
  import { listMyEnterprises } from '@/api/enterprise.js'
  import {
    personSearch,
    personAdd,
    personUpdate,
    personDelete,
    personUpdateRole,
  } from '@/api/person.js'
  export default {
    name: 'PersonIndex',
    data() {
      return {
        roleForm: {
          role: '',
        },
        enterPriseId: this.$store.getters.currentEnterprise.id,
        pageNum: 1,
        value: 16,
        total: 0,
        employeeId: undefined,
        employeeName: null,
        employeeData: [],
        activeTab: 'newone',
        employeeFrom: {
          id: undefined,
          enterpriseName: '',
          entrId: '',
          name: '',
          password: '',
          sex: '',
          role: '', //角色
          status: '',
          phone: '',
        },
        rules: {
          name: [
            { required: true, message: '员工名称不能为空', trigger: 'blur' },
          ],
          role: [{ required: true, message: '工种不能为空', trigger: 'blur' }],
          phone: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
          password: [
            { required: true, message: '密码不能为空', trigger: 'blur' },
          ],
        },
        workOption: [
          {
            label: '工人',
            value: 'product-executor',
          },
          {
            label: '管理',
            value: 'product-manager',
          },
        ],
        statusOption: [
          {
            label: '在职',
            value: '0',
          },
          {
            label: '离职',
            value: '1',
          },
          {
            label: '实习',
            value: '2',
          },
        ],
      }
    },
    methods: {
      roleSave() {
        personUpdateRole(this.employeeFrom.id, {
          entrId: this.enterpriseId,
          id: this.employeeFrom.id,
          role: this.roleForm.role,
        }).then((data) => {
          this.$message.success(data.message)
          this.personSearch()
        })
      },
      cancel() {},
      handleSizeChange(val) {
        this.value = val
        this.pageNum = 1
        this.personSearch()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.personSearch()
      },
      search() {
        if (this.employeeName == '') {
          this.employeeName = null
        }
        this.pageNum = 1
        this.personSearch()
      },
      personSearch() {
        this.enterpriseId = this.$store.getters.currentEnterprise.id
        let option = {
          pageNum: this.pageNum,
          pageSize: this.value,
          enterpriseId: this.enterpriseId,
          name: this.employeeName,
        }
        personSearch(this.enterpriseId, option).then((data) => {
          this.employeeData = data.data.list
          this.total = data.data.total
        })
      },
      save() {
        if (!this.employeeId) {
          this.$refs.employeeFrom.validate((valid) => {
            if (valid) {
              this.employeeFrom.entrId = this.enterPriseId
              personAdd(this.employeeFrom)
                .then((data) => {
                  this.employeeName = null
                })
                .then(() => {
                  this.personSearch()
                  this.$message.success('提交成功')
                  this.$refs.employeeFrom.resetFields()
                })
            }
          })
        } else {
          this.$refs.employeeFrom.validate((valid) => {
            if (valid) {
              this.employeeFrom.enterpriseId = this.enterPriseId
              personUpdate(this.employeeFrom).then((data) => {
                this.employeeName = null
                this.personSearch()
                this.$message.success('提交成功')
                this.addEmployee()
              })
            }
          })
        }
      },
      addEmployee() {
        this.employeeId = undefined
        this.employeeFrom.id = undefined
        this.$refs.employeeFrom.resetFields()
      },
      //编辑
      update(id) {

        this.$router.push({
          path: `editor/${id}`,
        })
        // this.$refs.employeeFrom.clearValidate()
        // this.employeeId = row.id
        // this.employeeFrom.id = row.id
        // this.employeeFrom.name = row.name
        // this.employeeFrom.profession = row.profession
        // this.employeeFrom.sex = row.sex
        // this.employeeFrom.status = row.status
        // this.roleForm.role = row.role
        // this.employeeFrom.phone = row.phone
      },
      clearFrom() {
        this.$refs.employeeFrom.resetFields()
      },
      remove(id) {
        personDelete(id).then((data) => {
          this.personSearch()
        })
      },
    },
    computed: {
      title: function () {
        return this.employeeId ? '编辑' : '新增'
      },
    },
    filters: {
      roleString: function (val) {
        if (val === 'product-executor') {
          return '工人'
        } else if (val === 'product-manager') {
          return '管理'
        }
      },
    },
    created() {
      listMyEnterprises(this.$store.getters.userId).then((r) => {
        this.employeeFrom.enterpriseName = r.data.find(
          (item) => item.id === this.$store.getters.currentEnterprise.id
        ).name
      })
    },
    mounted() {
      this.personSearch()
      console.log('【↑↑↑】', this.$options.name)
    },
    beforeDestroy() {
      console.log('【↓↓↓】', this.$options.name)
    },
  }
</script>
<style>
  .employListbox {
    background: #fff;
    border: 1px solid #dcdfe6;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
    padding: 8px;
    min-height: 603px;
  }
  .el-message {
    margin-top: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/meta/person/PersonList.vue